import { ArrowRight } from "lucide-react";
import { Link } from "react-router";

import { Eyebrow } from "@/components/eyebrow";
import { PageShell } from "@/components/page-shell";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <PageShell>
      <div className="py-12 text-center">
        <Eyebrow>404</Eyebrow>
        <h1 className="text-primary mt-3 text-4xl font-normal tracking-tight sm:text-5xl">
          Not found.
        </h1>
        <p className="text-muted-foreground mt-4">That assessment or page doesn’t exist.</p>
        <Button asChild className="mt-8">
          <Link to="/">
            Back home <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </PageShell>
  );
}
